import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/client/$accountId/sources',
      params: { accountId: params.accountId },
      replace: true,
    });
  },
});
